import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue);
Vue.use(Router);


const router =  new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '',
            name: 'Home',
            component: () => import('../views/dashboard')
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('../views/about')
        },
        {
            path:'/diffuser',
            name: 'diffuser',
            component: () => import('../views/sound-diffuser')
        },

        {
            path: '/gallery',
            name: 'gallery',
            component: () => import('../views/Gallery')
        },
        {
            path: '/eco',
            name: 'eco',
            component: () => import('../views/eco')
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '*',
            name: '*',
            component: () => import('../views/dashboard')
        }

    ],
});

router.beforeEach((to, from, next) => {
    if (to.name !== 'Login' && !localStorage.getItem('token')) next({ name: 'Login' });
    else if(to.name === 'Login' && localStorage.getItem('token')) next({name: 'Home'});
    else next()
});


export default router;